import { usePlantInfosApi } from '../../infrastructure/api/usePlantInfosApi'

export const usePlantInfosUseCase = () => {
  const { getChargeExploitation, getPlantInfos } = usePlantInfosApi()
  return {
    getPlantInfos: async (centraleId: number) => {
      return getPlantInfos(centraleId)
    },

    getChargeExploitation: async (mail: string) => {
      return getChargeExploitation(mail)
    },
  }
}
